import { render, staticRenderFns } from "./Applicant.vue?vue&type=template&id=589e1a16&scoped=true"
import script from "./Applicant.vue?vue&type=script&lang=js"
export * from "./Applicant.vue?vue&type=script&lang=js"
import style0 from "./applicant.css?vue&type=style&index=0&id=589e1a16&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589e1a16",
  null
  
)

export default component.exports